import { useEffect, useContext } from 'react';

import { ArticleContext } from '../../Article.context';
import styles from '../../article.module.css';

export const VirtualInfogram = (props: InfogramProps) => {
	const {
		id = '',
		dataId = '',
		bleed = false,
		fullWidth = false,
		expandFullWidth = false,
		fixedWidth,
		width,
	} = props;
	if (!dataId) {
		return null;
	}
	useEffect(() => {
		InfogramEmbed(document, 0, 'infogram-async');
	}, [dataId]);
	const articleContext = useContext(ArticleContext);
	const containerStyle: any = {};
	let componentStyle: any = {};

	if (fullWidth) {
		containerStyle.minWidth = '100%';
		containerStyle.width = '100%';
	}

	if (expandFullWidth) {
		componentStyle.minWidth = '100%';
		componentStyle.width = '100%';
	}

	if (fixedWidth && width) {
		componentStyle = {
			minWidth: width,
			width: width,
			maxWidth: width,
		};
	}

	if (fullWidth && expandFullWidth) {
		componentStyle = {
			minWidth: articleContext.width,
			width: articleContext.width,
		};
	}
	return (
		<div
			id={id}
			className={`${styles['infogram']} ${
				bleed && !fullWidth ? 'bleed' : ''
			}`}
			style={containerStyle}
		>
			<div
				className="infogram-embed"
				data-id={dataId}
				style={componentStyle}
				data-type="interactive"
			/>
		</div>
	);
};

function InfogramEmbed(e: any, i: any, n: any) {
	const w: any = window;
	const t: any = 'InfogramEmbeds',
		d: any = e.getElementsByTagName('script')[0];
	if (w[t] && w[t].initialized) w[t].process && w[t].process();
	else if (!e.getElementById(n)) {
		const o = e.createElement('script');
		o.async = 1;
		o.id = n;
		o.src = 'https://e.infogram.com/js/dist/embed-loader-min.js';
		d.parentNode.insertBefore(o, d);
	}
}

interface InfogramProps {
	id: string;
	dataId: string;
	bleed: boolean;
	fullWidth: boolean;
	expandFullWidth: boolean;
	width: number;
	fixedWidth: boolean;
}
